import React from 'react';
import { Box, Button } from '@material-ui/core';

import ppSuccess from 'assets/onboarding/ppSuccess.avif';
import { ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { ModalStep } from 'components/Flow/components/ModalStep';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import Img from 'retired/Img';

export const PayPalSuccess = ({ send }: StepComponentProps): JSX.Element => (
  <ModalStep
    showProgressBar
    actions={
      <div>
        <Button type="button" variant="contained" onClick={(): void => send('NEXT')}>
          Next
        </Button>
      </div>
    }
    header={<Img src={ppSuccess} width={293} alt="PayPal icon" />}
    headerStyles={{
      paddingTop: 16,
    }}
  >
    <Box mb={4}>
      <ModalTitle size="large">Your verification was successful!</ModalTitle>
      <ModalTypography>
        Your PayPal verification was confirmed and you’re now the owner of this organization. Please
        continue to complete your onboarding.
      </ModalTypography>
    </Box>
  </ModalStep>
);
